import Logout24 from '@carbon/icons-react/es/logout/24';
import { Menu as AntMenu, Space as AntSpace } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { CalendarIntegration } from 'api/timesheets/integration/calendar-integration-provider';
import { Avatar } from 'components/atoms/avatar';
import { Button } from 'components/atoms/button';
import {
  Caption01,
  ProductiveHeading07,
  SingleLineEllipsis,
  Text01,
  Text02,
} from 'components/styles';

const Card = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: var(--spacing-03);
`;

const Space = styled(AntSpace)`
  max-width: 200px;
`;

const Name = styled.div`
  ${ProductiveHeading07};
  ${Text01};
  ${SingleLineEllipsis};
`;
const Email = styled.div`
  ${Caption01};
  ${Text02};
  ${SingleLineEllipsis};
`;
const Menu = styled(AntMenu)`
  border: none;
`;

const MenuItem = styled(Menu.Item)`
  && {
    padding: 0 var(--spacing-05);
    height: var(--height-base);
    margin: 0;
    button,
    svg {
      margin: 0;
    }
    :hover {
      color: var(--blue-60);
      button {
        color: var(--blue-60);
      }
    }
  }
`;

const UserCardMenuItem = styled(MenuItem)`
  &&& {
    height: calc(2 * var(--height-base));
    cursor: default;
  }
`;
const StyledNavLink = styled(Button)`
  &:focus,
  &:hover {
    background-color: inherit;
    color: inherit;
  }
  width: 100%;
  transition: none;
`;

const MenuDivider = styled(Menu.Divider)`
  margin: var(--layout-01);
`;

interface Props {
  meta: CalendarIntegration['meta'];
  onClick: () => any;
}

export const ProfileMenu: FC<Props> = ({
  meta: {
    oauthAuthenticatorAccountName: userName,
    oauthAuthenticatorEmail: email,
    oauthAuthenticatorAccountProfileUrl: photoUrl,
  },
  onClick,
}) => (
  <Menu>
    <UserCardMenuItem>
      <div>
        <Card>
          <Space direction="vertical" size={4}>
            <Name title={userName}>{userName}</Name>
            <Email title={email}>{email}</Email>
          </Space>
          <Avatar src={photoUrl} name={userName} />
        </Card>
      </div>
    </UserCardMenuItem>
    <MenuDivider />
    <MenuItem icon={<Logout24 />} id="logout">
      <StyledNavLink type="text" onClick={onClick}>
        <FormattedMessage id="disconnect" />
      </StyledNavLink>
    </MenuItem>
  </Menu>
);
